import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    checkboxContainer: 'group relative flex items-center bg-transparent',
    checkbox:
      'border-bg-items-black group-hover:border-icon-hover data-[checked]:bg-text-main group-hover:data-[checked]:border-brand-400 group-hover:data-[checked]:bg-brand-400 flex size-6 min-w-6 cursor-pointer items-center justify-center rounded-[4px] border transition-colors duration-200 focus:outline-none',
    label:
      'group-hover:text-icon-secondary font-regular cursor-pointer pl-3 text-base transition-colors duration-200',
    helperText: 'mt-1 text-[12px] font-light',
    icon: 'opacity-0 group-has-[[data-checked]]:opacity-100'
  },
  variants: {
    error: {
      true: {
        checkbox:
          'border-brand-400 group-has-[[data-checked]]:bg-brand-400 data-[checked]:bg-brand-400',
        helperText: 'text-text-error border-brand-400'
      }
    },
    disabled: {
      true: {
        label:
          'text-text-inactive group-hover:text-text-inactive cursor-not-allowed',
        checkbox:
          'border-bg-items-medium data-[checked]:bg-bg-items-medium group-hover:border-bg-items-medium cursor-not-allowed'
      }
    }
  }
});
